/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  error: '',
  loading: false,
  community_suggested_sequences: [],
  community_suggested_workpackages: [],
  community_suggested_waggons: [],
  community_suggested_materials: [],
  community_sequences: [],
  community_workpackages: [],
  community_waggons: [],
  community_materials: [],
  community_latest: {},
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getError: (state) => state.error,
  getCommunitySequences: (state) => state.community_sequences,
  getCommunitySequencesFiltered: (state) => (search) => {
    if (search !== '') {
      return state.community_sequences.filter(sequence =>
        sequence.name.toLowerCase().includes(search.toLowerCase()) ||
        sequence.hashtags.filter(hashtag => {
          hashtag.tag.toLowerCase().includes(search.toLowerCase());
        }).length !== 0
      );
    } else {
      return state.community_sequences;
    }
  },
  getCommunityWorkPackages: (state) => state.community_workpackages,
  getCommunityWorkPackage: (state) => (id) => {
    return state.community_workpackages.find(work_package => work_package.id === id);
  },
  getCWorkPackagesFiltered: ( state ) => (search) => {
    if (search !== '') {
      return state.community_workpackages.filter(work_package =>
        work_package.token.toLowerCase().includes(search.toLowerCase()) ||
        work_package.name.toLowerCase().includes(search.toLowerCase()));
    } else {
      return state.community_workpackages;
    }
  },
  getCommunityWaggons: (state) => state.community_waggons,
  getCommunityMaterials: (state) => state.community_materials,
  getCommunitySuggestedSequences: (state) => state.community_suggested_sequences,
  getCommunitySuggestedWorkPackages: (state) => state.community_suggested_workpackages,
  getCommunitySuggestedWaggons: (state) => state.community_suggested_waggons,
  getCommunitySuggestedMaterials: (state) => state.community_suggested_materials,
  isLoading: (state) => state.loading,
  getCommunityLatest: (state) => state.community_latest
};
// Actions
const actions = {
  requestCommunitySuggested({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'community/suggested',
        method: 'GET',
        headers: {
          'cache-control': 'no-cache',
        }
      })
      .then(resp => {
          commit('set_community_suggested_sequences', resp.data.data.sequences);
          commit('set_community_suggested_waggons', resp.data.data.waggons);
          commit('set_community_suggested_workpackages', resp.data.data.workpackages);
          commit('set_community_suggested_materials', resp.data.data.materials);
          ////commit('set_loading', false);
          resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        ////commit('set_loading', false);
        reject();
      });
    });
  },
  requestCommunitySequences({
    commit
  }) {
    return new Promise((resolve, reject) => {
      //commit('set_loading', true);
      axios({
          url: 'community/csequences?show=showForSequence',
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
        .then(resp => {
          commit('set_community_sequences', resp.data.data);
          ////commit('set_loading', false);
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          ////commit('set_loading', false);
          reject();
        });
    });
  },
  requestCommunitySequencesByHashtags({
    commit
  }, payload) {
    let hashtags = payload.hashtags.split(' ');
    let hashtag_query_string = '?';
    for (var i = 0; i < hashtags.length; i++) {
      hashtag_query_string+= 'hashtags[]=' + hashtags[i];
    }
    //commit('set_loading', true);
    axios({
        url: 'community/csequences' + hashtag_query_string + '&show=showForSequence',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_community_sequences', resp.data.data);
        ////commit('set_loading', false);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        ////commit('set_loading', false);
      });
  },
  requestCommunityWorkPackagesByHashtags({
    commit
  }, payload) {
    let hashtags = payload.hashtags.split(' ');
    let hashtag_query_string = '?';
    for (var i = 0; i < hashtags.length; i++) {
      hashtag_query_string+= 'hashtags[]=' + hashtags[i];
    }
    //commit('set_loading', true);
    axios({
        url: 'community/cworkpackages' + hashtag_query_string + '&show=showWithEntities',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_community_workpackages', resp.data.data);
        ////commit('set_loading', false);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        ////commit('set_loading', false);
      });
  },
  requestCommunityWaggonsByHashtags({
    commit
  }, payload) {
    let hashtags = payload.hashtags.split(' ');
    let hashtag_query_string = '?';
    for (var i = 0; i < hashtags.length; i++) {
      hashtag_query_string+= 'hashtags[]=' + hashtags[i] + '&';
    }
    //commit('set_loading', true);
    axios({
        url: 'community/cwaggons' + hashtag_query_string + 'show=showWithEntities',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('set_community_waggons', resp.data.data);
        ////commit('set_loading', false);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        ////commit('set_loading', false);
      });
  },
  declineSequenceCommunityState({
    commit
  }, payload) {
    let url = 'sequences/' + payload.el.id + '/declinecommunitystate';
    if (payload.el.template_type == 'business') {
      url = 'businesses/0/bsequences/' + payload.el.id + '/declinecommunitystate';
    }
    axios({
        url: url,
        method: 'PUT',
        data: {
          reason: payload.reason
        }
      })
      .then(() => {
        commit('remove_community_suggested_sequence', payload.el.id);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
      });
  },
  declineWorkPackageCommunityState({
    commit
  }, payload) {
    let url = 'workpackages/' + payload.el.id + '/declinecommunitystate';
    if (payload.el.template_type == 'business') {
      url = 'businesses/0/bworkpackages/' + payload.el.id + '/declinecommunitystate';
    }
    axios({
        url: url,
        method: 'PUT',
        data: {
          reason: payload.reason
        }
      })
      .then(() => {
        commit('remove_community_suggested_workpackage', payload.el.id);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
      });
  },
  declineWaggonCommunityState({
    commit
  }, payload) {
    let url = 'waggons/' + payload.el.id + '/declinecommunitystate';
    if (payload.el.template_type == 'business') {
      url = 'businesses/0/bwaggons/' + payload.el.id + '/declinecommunitystate';
    }
    axios({
        url: url,
        method: 'PUT',
        data: {
          reason: payload.reason
        }
      })
      .then(() => {
        commit('remove_community_suggested_waggon', payload.el.id);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
      });
  },
  declineMaterialCommunityState({
    commit
  }, payload) {
    let url = 'materials/' + payload.el.id + '/declinecommunitystate';
    if (payload.el.template_type == 'business') {
      url = 'businesses/0/bmaterials/' + payload.el.id + '/declinecommunitystate';
    }
    axios({
        url: url,
        method: 'PUT',
        data: {
          reason: payload.reason
        }
      })
      .then(() => {
        commit('remove_community_suggested_material', payload.el.id);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
      });
  },
  acceptAndCreateCommunitySequence({
    commit
  }, payload) {
    //commit('set_loading', true);
    axios({
        url: 'community/csequences',
        method: 'POST',
        data: {
          sequence: payload.el.id,
          template_type: payload.el.template_type
        }
      })
      .then(resp => {
        commit('add_community_sequence', resp.data.data);
        commit('remove_community_suggested_sequence', payload.el.id);
        ////commit('set_loading', false);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        ////commit('set_loading', false);
      });
  },
  acceptAndCreateCommunityWorkPackage({
    commit
  }, payload) {
    //commit('set_loading', true);
    axios({
        url: 'community/cworkpackages',
        method: 'POST',
        data: {
          work_package: payload.el.id,
          template_type: payload.el.template_type
        }
      })
      .then(resp => {
        commit('add_community_workpackage', resp.data.data);
        commit('remove_community_suggested_workpackage', payload.el.id);
        ////commit('set_loading', false);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        ////commit('set_loading', false);
      });
  },
  acceptAndCreateCommunityMaterial({
    commit
  }, payload) {
    //commit('set_loading', true);
    axios({
        url: 'community/cmaterials',
        method: 'POST',
        data: {
          material: payload.el.id,
          template_type: payload.el.template_type
        }
      })
      .then(resp => {
        commit('add_community_material', resp.data.data);
        commit('remove_community_suggested_material', payload.el.id);
        ////commit('set_loading', false);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        ////commit('set_loading', false);
      });
  },
  acceptAndCreateCommunityWaggon({
    commit
  }, payload) {
    //commit('set_loading', true);
    axios({
        url: 'community/cwaggons',
        method: 'POST',
        data: {
          waggon: payload.el.id,
          template_type: payload.el.template_type
        }
      })
      .then(resp => {
        commit('add_community_waggon', resp.data.data);
        commit('remove_community_suggested_waggon', payload.el.id);
        ////commit('set_loading', false);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        ////commit('set_loading', false);
      });
  },
  deleteCommunitySequence({
    commit
  }, payload) {
    //commit('set_loading', true);
    axios({
        url: 'community/csequences/' + payload.csequence_id,
        method: 'DELETE'
      })
      .then(() => {
        commit('remove_community_sequence', payload.csequence_id);
        ////commit('set_loading', false);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        ////commit('set_loading', false);
      });
  },
  deleteCommunityWorkPackage({
    commit
  }, payload) {
    //commit('set_loading', true);
    axios({
        url: 'community/cworkpackages/' + payload.cworkpackage_id,
        method: 'DELETE'
      })
      .then(() => {
        commit('remove_community_workpackage', payload.cworkpackage_id);
        ////commit('set_loading', false);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        //commit('set_loading', false);
      });
  },
  deleteCommunityWaggon({
    commit
  }, payload) {
    //commit('set_loading', true);
    axios({
        url: 'community/cwaggons/' + payload.cwaggon_id,
        method: 'DELETE'
      })
      .then(() => {
        commit('remove_community_waggon', payload.cwaggon_id);
        //commit('set_loading', false);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        //commit('set_loading', false);
      });
  },
  likeCommunitySequence({
    commit
  }, payload) {
    //commit('set_loading', true);
    axios({
        url: 'community/csequences/' + payload.csequence_id + '/like',
        method: 'PUT'
      })
      .then(() => {
        axios({
            url: 'community/csequences/' + payload.csequence_id + '?show=showForSequence',
            method: 'GET',
            headers: {
              'Cache-Control': 'no-cache'
            }
          })
          .then(resp => {
            let csequence = resp.data.data;
            commit('replace_community_sequence', csequence);
            //commit('set_loading', false);
          })
          .catch(err_2 => {
            commit('set_error', extractErrorDetails(err_2));
            //commit('set_loading', false);
          });
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        //commit('set_loading', false);
      });
  },
  likeCommunityWorkPackage({
    commit
  }, payload) {
    //commit('set_loading', true);
    axios({
        url: 'community/cworkpackages/' + payload.cworkpackage_id + '/like',
        method: 'PUT'
      })
      .then(() => {
        axios({
            url: 'community/cworkpackages/' + payload.cworkpackage_id + '?show=showWithEntities',
            method: 'GET',
            headers: {
              'Cache-Control': 'no-cache'
            }
          })
          .then(resp => {
            let cworkpackage = resp.data.data;
            commit('replace_community_workpackage', cworkpackage);
            //commit('set_loading', false);
          })
          .catch(err_2 => {
            commit('set_error', extractErrorDetails(err_2));
            //commit('set_loading', false);
          });
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        //commit('set_loading', false);
      });
  },
  likeCommunityWaggon({
    commit
  }, payload) {
    //commit('set_loading', true);
    axios({
        url: 'community/cwaggons/' + payload.cwaggon_id + '/like',
        method: 'PUT'
      })
      .then(() => {
        axios({
            url: 'community/cwaggons/' + payload.cwaggon_id + '?show=showWithEntities',
            method: 'GET',
            headers: {
              'Cache-Control': 'no-cache'
            }
          })
          .then(resp => {
            let cwaggon = resp.data.data;
            commit('replace_community_waggon', cwaggon);
            //commit('set_loading', false);
          })
          .catch(err_2 => {
            commit('set_error', extractErrorDetails(err_2));
            //commit('set_loading', false);
          });
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        //commit('set_loading', false);
      });
  },
  unlikeCommunitySequence({
    commit
  }, payload) {
    //commit('set_loading', true);
    axios({
        url: 'community/csequences/' + payload.csequence_id + '/unlike',
        method: 'PUT'
      })
      .then(() => {
        axios({
            url: 'community/csequences/' + payload.csequence_id + '?show=showForSequence',
            method: 'GET',
            headers: {
              'Cache-Control': 'no-cache'
            }
          })
          .then(resp => {
            let csequence = resp.data.data;
            commit('replace_community_sequence', csequence);
            //commit('set_loading', false);
          })
          .catch(err_2 => {
            commit('set_error', extractErrorDetails(err_2));
            //commit('set_loading', false);
          });
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        //commit('set_loading', false);
      });
  },
  unlikeCommunityWorkPackage({
    commit
  }, payload) {
    //commit('set_loading', true);
    axios({
        url: 'community/cworkpackages/' + payload.cworkpackage_id + '/unlike',
        method: 'PUT'
      })
      .then(() => {
        axios({
            url: 'community/cworkpackages/' + payload.cworkpackage_id + '?show=showWithEntities',
            method: 'GET',
            headers: {
              'Cache-Control': 'no-cache'
            }
          })
          .then(resp => {
            let cworkpacakge = resp.data.data;
            commit('replace_community_workpacakge', cworkpacakge);
            //commit('set_loading', false);
          })
          .catch(err_2 => {
            commit('set_error', extractErrorDetails(err_2));
            //commit('set_loading', false);
          });
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        //commit('set_loading', false);
      });
  },
  unlikeCommunityWaggon({
    commit
  }, payload) {
    //commit('set_loading', true);
    axios({
        url: 'community/cwaggons/' + payload.cwaggon_id + '/unlike',
        method: 'PUT'
      })
      .then(() => {
        axios({
            url: 'community/cwaggons/' + payload.cwaggon_id + '?show=showWithEntities',
            method: 'GET',
            headers: {
              'Cache-Control': 'no-cache'
            }
          })
          .then(resp => {
            let cwaggon = resp.data.data;
            commit('replace_community_waggon', cwaggon);
            //commit('set_loading', false);
          })
          .catch(err_2 => {
            commit('set_error', extractErrorDetails(err_2));
            //commit('set_loading', false);
          });
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        //commit('set_loading', false);
      });
  },
  requestCWorkPackages({ commit }){
    //commit('set_loading', true);
    return new Promise((resolve, reject)=> {
    axios({
        url: 'community/cworkpackages?show=showWithEntities',
        method: 'GET'
      })
      .then(resp => {
        commit('set_community_workpackages', resp.data.data);
        //commit('set_loading', false);
        resolve();
        })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        //commit('set_loading', false);
        reject();
      });
    });
  },
  requestCWaggons({ commit }){
    //commit('set_loading', true);
    axios({
        url: 'community/cwaggons?show=showWithEntities',
        method: 'GET'
      })
      .then(resp => {
        commit('set_community_waggons', resp.data.data);
        //commit('set_loading', false);
        })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        //commit('set_loading', false);
      });
  },
  requestLatestCommunityEntities({ commit }) {

    axios({
      url: 'community/latest',
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
    .then(resp => {
      commit('set_community_latest', resp.data.data);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  }
};
// Mutations
const mutations = {
  add_community_sequence(state, community_sequence) {
    state.community_sequences = [
      ...state.community_sequences,
      community_sequence
    ];
  },
  add_community_workpackage(state, community_workpackage) {
    state.community_workpackages = [
      ...state.community_workpackages,
      community_workpackage
    ];
  },
  add_community_waggon(state, community_waggon) {
    state.community_waggons = [
      ...state.community_waggons,
      community_waggon
    ];
  },
  add_community_material(state, community_material) {
    state.community_materials = [
      ...state.community_materials,
      community_material
    ];
  },
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  remove_community_suggested_sequence(state, sequence_id) {
    state.community_suggested_sequences = [
      ...state.community_suggested_sequences.filter(suggested_sequence => suggested_sequence.id !== sequence_id),
    ];
  },
  remove_community_suggested_workpackage(state, workpackage_id) {
    state.community_suggested_workpackages = [
      ...state.community_suggested_workpackages.filter(suggested_workpackage => suggested_workpackage.id !== workpackage_id),
    ];
  },
  remove_community_suggested_waggon(state, waggon_id) {
    state.community_suggested_waggons = [
      ...state.community_suggested_waggons.filter(suggested_waggon => suggested_waggon.id !== waggon_id),
    ];
  },
  remove_community_suggested_material(state, material_id) {
    state.community_suggested_materials = [
      ...state.community_suggested_materials.filter(suggested_material => suggested_material.id !== material_id),
    ];
  },
  remove_community_sequence(state, csequence_id) {
    state.community_sequences = [
      ...state.community_sequences.filter(csequence => csequence.id !== csequence_id),
    ];
  },
  remove_community_workpackage(state, cworkpackage_id) {
    state.community_workpackages = [
      ...state.community_workpackages.filter(cworkpackage => cworkpackage.id !== cworkpackage_id),
    ];
  },
  remove_community_waggon(state, cwaggon_id) {
    state.community_waggons = [
      ...state.community_waggons.filter(cwaggon => cwaggon.id !== cwaggon_id),
    ];
  },
  remove_community_material(state, cmaterial_id) {
    state.community_materials = [
      ...state.community_materials.filter(cmaterial => cmaterial.id !== cmaterial_id),
    ];
  },
  replace_community_sequence(state, csequence) {
    const index = state.community_sequences.findIndex(function(item) {
      return item.id == csequence.id;
    });
    state.community_sequences = [
      ...state.community_sequences.slice(0, index),
      csequence,
      ...state.community_sequences.slice(index + 1)
    ];
  },
  replace_community_workpackage(state, cworkpackage) {
    const index = state.community_workpackages.findIndex(function(item) {
      return item.id == cworkpackage.id;
    });
    state.community_workpackages = [
      ...state.community_workpackages.slice(0, index),
      cworkpackage,
      ...state.community_workpackages.slice(index + 1)
    ];
  },
  replace_community_waggon(state, cwaggon) {
    const index = state.community_waggons.findIndex(function(item) {
      return item.id == cwaggon.id;
    });
    state.community_waggons = [
      ...state.community_waggons.slice(0, index),
      cwaggon,
      ...state.community_waggons.slice(index + 1)
    ];
  },
  replace_community_material(state, cmaterial) {
    const index = state.community_materials.findIndex(function(item) {
      return item.id == cmaterial.id;
    });
    state.community_materials = [
      ...state.community_materials.slice(0, index),
      cmaterial,
      ...state.community_materials.slice(index + 1)
    ];
  },
  set_error(state, err) {
    state.error = err;
  },
  set_loading(state, loading) {
    state.loading = loading;
  },
  set_community_suggested_sequences(state, community_suggested_sequences) {
    state.community_suggested_sequences = [...community_suggested_sequences];
  },
  set_community_suggested_workpackages(state, community_suggested_workpackages) {
    state.community_suggested_workpackages = [...community_suggested_workpackages];
  },
  set_community_suggested_waggons(state, community_suggested_waggons) {
    state.community_suggested_waggons = [...community_suggested_waggons];
  },
  set_community_suggested_materials(state, community_suggested_materials) {
    state.community_suggested_materials = [...community_suggested_materials];
  },
  set_community_sequences(state, community_sequences) {
    state.community_sequences = [...community_sequences];
  },
  set_community_workpackages(state, community_workpackages) {
    state.community_workpackages = [...community_workpackages];
  },
  set_community_waggons(state, community_waggons) {
    state.community_waggons = [...community_waggons];
  },
  set_community_materials(state, community_materials) {
    state.community_materials = [...community_materials];
  },
  set_community_latest(state, community_latest) {
    state.community_latest = community_latest;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
